import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components

export class Header extends Component  {
  state = { }

  componentDidMount() {
    // const getMobileMenu = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/758');

    // Promise.all([getMobileMenu]).then(res => {
    //   console.dir(res);
    //   this.setState({
    //     mobileMenu: res[0].data.items
    //   });
    // });
  }

  render() {
    // const { mobileMenu } = this.state;
    // console.dir(this.state);

    return (
      <>
        <header>
          <div className="container">
            <div className="row">
              <div className="col-6 col-offset-3">

                <div className="title">
                <img src={process.env.PUBLIC_URL + '/global/images/crest512.png'} className="logo" alt="University of St. Augustine" />
                  <h1>USAHS Health<br/> Screening Form</h1>
                </div>

                <p>The University of St. Augustine for Health Sciences (USAHS) strives to provide a safe and healthy environment. This requires continued monitoring to ensure the health of those that enter our campuses each day or attend events sponsored by the University. Completion of the self-reported health screening questions below is required before you enter the event. You will not be asked to share your personal data.</p>

                <p>If you are not cleared to enter, please do not come to the event held by USAHS.</p>

              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Header;